<template>
  <div class="content">
    <h2 style="font-size: 0.2rem;">联考之家隐私政策</h2>
    <span class="content-data">更新日期：2023年12月7日</span>
    <br>
    <span class="content-data">生效日期：2023年12月7日</span>
    <p>博雅爱文MBA联考之家（网址：http://www.mba001.com/）（以下简称“联考之家”）致力于为社会提供MBA招生信息、MBA资讯、备考资料下载和素质发展相关的专业化信息咨询服务，尊重并致力于保护用户个人数据与隐私安全。我们深知个人信息对您的重要性，我们将按照法律法规要求，采取相应安全保护措施，尽最大努力保护您的个人信息安全可控。因此，我们制定了本隐私政策并提醒您：</p>
    <p>本隐私政策适用于联考之家产品和服务，包括联考之家网页版、联考之家客户端软件、联考之家移动端APP（应用名称：联考之家、开发者：小尚）、联考之家小程序。</p>
    <p>在使用联考之家产品或服务前，请您务必仔细阅读并透彻理解本隐私政策内容，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用联考之家的产品或服务，便视为您已充分理解并接受本隐私政策。</p>
    <p>如果您对我们的隐私政策有任何的疑问或建议，请通过文末的联系方式与我们联系。</p>
    <p>本隐私政策将帮助您了解以下内容：</p>
    <p>一、我们如何收集您的个人信息</p>
    <p>二、我们如何使用您的个人信息</p>
    <p>三、我们如何共享、转让、公开披露您的个人信息</p>
    <p>四、我们如何存储和保护您的个人信息</p>
    <p>五、您如何管理您的个人信息</p>
    <p>六、本隐私政策的变更</p>
    <p>七、法律适用与管辖</p>
    <p>八、联系我们</p>
    <h3 style="font-size: 0.16rem;">一、我们如何收集您的个人信息</h3>
    <p>为了向您提供更加准确、便捷、高质量的服务，并确保您的信息安全，在您使用联考之家服务过程中，我们会收集您主动输入或因使用服务而产生的以下信息：</p>
    <h4 style="font-size: 0.14rem;">1.注册成为联考之家用户时提供的信息</h4>
    <p>(1)如果您注册成为我们的用户，您需要提供真实有效的电子邮箱和手机号码信息来创建账户。</p>
    <p>(2)如果您需要使用我们提供的高等教育招生、学籍学历学位、就业、征兵和素质发展相关的信息服务，您还需要通过实名认证。实名认证需要您提供姓名、有效证件号码基本信息，必要时还需要您提供脸部图像信息。极少数特殊情况下，您还需要同时提供脸部图像和有效身份证件图像信息以验证身份。</p>
    <p>(3)当您使用微信或支付宝授权登录功能时，我们需要您提供微信或支付宝账号的昵称与头像信息，以进行微信或支付宝账号关联与用户头像的设置。</p>
    <p>如果您拒绝提供上述信息，您可能无法注册联考之家用户或无法正常使用我们的服务。</p>
    <p>如果您仅需浏览或使用联考之家提供的公共信息服务，您不需要注册成为我们的用户，也不需要提供上述信息。</p>
    <h4 style="font-size: 0.14rem;">2.使用我们的产品或服务过程中收集的信息</h4>
    <p>(1)为改善我们的产品或服务，我们会根据您使用产品或服务的设备信息、位置信息、日志信息进行关联及分析，以便向您提供更契合您需求的信息咨询服务。这些信息包括：</p>
    <p>设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（设备型号、唯一设备标识符、操作系统版本、浏览器UA）。</p>
    <p>位置信息：指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集有关您位置的信息（GPS/北斗位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站传感器信息）。</p>
    <p>日志信息：当您使用我们提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。包括您的IP地址、接入网络的方式、电信运营商、使用的语言、访问日期和时间以及您的访问日志。这些信息是为您提供服务必须收集的基础信息，以保障您正常使用我们的服务。</p>
    <p>请注意，单独的设备信息、位置信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息。除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
    <p>(2)当您使用我们的高等教育学籍学历学位查询服务时，您需要提供证书持有人的姓名、证书编号信息，在特殊情况下，还需要提供证书持有人的有效证件号码信息。</p>
    <p>(3)当您使用我们提供的高等教育报名服务时，根据招生部门的政策要求，您还需要配合提供学习经历、家庭成员、获奖信息、户籍信息、联系地址以及招生部门要求采集的其他信息，以完成报名申请。如果您不提供这些信息，将会影响您的报名申请。</p>
    <p>(4)当您使用在线考试系统时，我们会根据您希望使用的功能依场景请求您授权相应功能所需的相机、相册、麦克风权限。我们不会主动获取相册中的照片，仅在您同意开启此权限并在相册中主动获取图片数据，将加密后存储于数据库中。</p>
    <p>(5)根据有关法律法规以及校验身份的需要，我们会在获得您的相机和相册权限后提供验证服务，仅获得校验的结果，不会保留相关信息。如果您拒绝提供该信息，仅会使您无法使用以身份核验为前提条件的相关功能，但不影响您使用本平台的其他功能。</p>
    <p>(6)我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。为确认交易状态及为您提供售后与争议解决服务，我们会通过您选择的交易对象、支付机构等收集与交易进度相关的您的交易、支付信息，或将您的交易信息共享给上述服务提供者。</p>
    <p>(7)当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
    <p>(8)当您通过我们的业务合作伙伴提供的入口，使用联考之家提供的产品或服务时，您需要授权我们根据实际业务及合作需要，从业务合作伙伴处接收、汇总、分析您的个人信息或交易信息（我们确认其来源合法或您授权同意其向我们提供的）。</p>
    <p>(9)为确保服务安全，帮助我们更好地了解联考之家运行情况，我们会记录联考之家运行的相关信息：您使用联考之家的频率、崩溃数据、总体使用情况、性能数据。我们不会将存储在分析软件中的信息与您在联考之家中输入的任何个人身份信息相结合。</p>
    <p>(10)Cookie是网页浏览器保存在您访问联考之家所使用的设备上的文本文件，会帮助您在后续访问时调用信息，简化您填写个人信息的流程。您有权接受或拒绝Cookie，如果浏览器自动接受Cookie，您可以根据自己的需要修改浏览器的设置以拒绝Cookie。</p>
    <p>(11)为确保部分独立功能的实现，使您能够使用更多的服务及功能，我们会在应用中嵌入第三方的SDK，我们将审慎评估该SDK的使用目的。了解更多有关SDK处理个人信息的目的、方式及范围等信息，请查看第三方信息共享清单。</p>
    <h4 style="font-size: 0.14rem;">3.征得授权同意的例外</h4>
    <p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
    <p>(1)与国家安全、国防安全有关的；</p>
    <p>(2)与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>(3)与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>(4)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
    <p>(5)所收集的个人信息是您自行向社会公众公开的；</p>
    <p>(6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>(7)根据您的要求签订和履行合同所必需的；</p>
    <p>(8)用于维护所提供服务的安全稳定运行所必需的；</p>
    <p>(9)为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
    <p>(10)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
    <p>(11)法律法规规定的其他情形。</p>
    <p>您上传至联考之家的任何内容应遵守国家相关法律、法规、规章制度的规定，不得含有以下内容：a.反动、色情、暴力等国家法律、法规禁止的信息；b.虚假、骚扰性、侮辱性、恐吓性、伤害性、挑衅性、庸俗性信息；c.侵犯其他任何第三方的专利权、版权、著作权、商标权、名誉权或其他任何合法权益的信息。</p>
    <p>您应保证上传至联考之家的内容未侵犯他人知识产权。如系第三方作品，您应当获得第三方的许可或未获得许可但有权合法使用第三方作品。除法律法规另有规定外，未获得第三方作品所有人的事先许可，您不得以任何方式使用第三方作品。</p>
    <p>如果我们停止运营联考之家的产品或服务，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并根据法律法规的要求处理您的个人信息。</p>
    <p>如果您不再使用联考之家的产品或服务，您可以要求联考之家注销您的账户并清除您的个人信息，请通过文末的联系方式与我们联系。</p>
    <h3 style="font-size: 0.16rem;">二、我们如何使用您的个人信息</h3>
    <p>1.您同意我们可将您的个人信息用于我们的其他服务或产品、问卷调查。</p>
    <p>2.为保证您的账户安全，我们的呼叫中心客服和在线客服会使用您的账户信息与您核验身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。</p>
    <p>3.研究分析。我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善联考之家的内容和布局，提供产品或服务的决策支撑，以及改进产品和服务，例如使用匿名数据进行机器学习或模型算法训练。</p>
    <p>4.为您提供安全保障。为提高您使用我们及我们合作伙伴提供服务的安全性，确保操作环境安全与识别注册账号异常状态，更好地保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或联考之家相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、有关网络日志以及我们合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
    <p>5.当我们要将您的个人信息，用于本政策载明的收集目的、用途或合理相关范围以外的其他用途时，我们将在使用前再次征得您的同意。</p>
    <h3 style="font-size: 0.16rem;">三、如何共享、转让、公开披露您的个人信息</h3>
    <h4 style="font-size: 0.14rem;">1.共享</h4>
    <p>我们不会与联考之家服务提供者以外的组织、公司和个人共享您的个人信息，但以下情况除外：</p>
    <p>(1)在获取明确同意的情况下共享：获取您的明确同意后，我们会与其他方共享您的个人信息；</p>
    <p>(2)在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要或按行政、司法机关依法提出的要求，对外共享您的个人信息；</p>
    <p>(3)与授权合作伙伴共享：根据您的选择，我们可能会向相关产品和服务的提供者共享您的部分信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。对于我们与之共享个人信息的公司、组织，我们会与其签署严格的保密协定，要求他们按照本隐私政策以及我们其他相关的保密和安全措施来处理您的个人信息。我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途，如要改变个人信息的用途，将再次征求您的授权同意。</p>
    <h4 style="font-size: 0.14rem;">2.转让</h4>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>(1)事先获得您的明确同意或授权；</p>
    <p>(2)根据适用的法律法规、法律程序的要求、强制性的行政或司法要求；</p>
    <p>(3)在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</p>
    <h4 style="font-size: 0.14rem;">3.公开披露</h4>
    <p>我们仅会在以下情形，公开披露您的个人信息：</p>
    <p>(1)在您明确同意或主动选择情况下，我们可能会公开披露您所指定的个人信息；</p>
    <p>(2)根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求对方必须出具与之相应的法律文件，如传票或调查函。</p>
    <h4 style="font-size: 0.14rem;">4.无需事先征得授权同意的例外情形</h4>
    <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
    <p>(1)与国家安全、国防安全有关的；</p>
    <p>(2)与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>(3)与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>(4)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
    <p>(5)您自行向社会公众公开的个人信息；</p>
    <p>(6)从合法公开披露的信息中收集的个人信息，如合法的新闻报道、政府信息公开等渠道。</p>
    <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
    <h3 style="font-size: 0.16rem;">四、我们如何存储和保护您的个人信息</h3>
    <p>1.我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。我们会确保依据本隐私政策对您的个人信息提供足够的保护，仅在为实现目的所必需的时间及法律、行政法规所规定的保存期限内保留您的个人信息。在符合适用法律规定的情形下如果确有必要进行数据的跨境传输，我们会征得您的授权同意，向您明确告知数据出境的目的、接收方、使用方式与范围、使用内容、安全保障措施、安全风险等，严格按照法律法规的规定执行，进行数据出境安全评估并保证您的个人信息安全。</p>
    <p>2.我们非常重视信息安全，成立了专门的负责团队提供信息保护，已采取符合业界标准、合理可行的技术防护措施保护您提供的个人信息安全。我们参照国内外信息安全标准及最佳实践建立了与业务发展相适应的信息安全保障体系，防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。</p>
    <p>3.我们从数据的生命周期角度出发，在数据收集、存储、显示、处理、使用、销毁等各个环节建立了安全防护措施，根据信息敏感程度的级别采取不同的控制措施，包括但不限于访问控制、SSL加密传输、加密存储、敏感信息脱敏显示等。</p>
    <p>4.我们对可能接触到您个人信息的员工也采取了严格管理，部署访问控制机制，监控他们的操作情况，尽力确保只有授权人员才可访问个人信息，对于数据访问、内外部传输使用、脱敏、解密等重要操作建立了审批机制，并与上述员工签署保密协议等。与此同时，我们还定期对员工进行安全和隐私保护培训，加强员工对于保护个人信息重要性的认识，提升数据保护意识和能力。</p>
    <p>5.您的账户均有安全保护功能，请妥善保管您的账户及密码信息，切勿将密码告知他人或第三方网站，如果您发现自己的个人信息泄露，特别是您的账户和密码发生泄露，请您立即与我们的客服人员联系，以便我们采取相应的措施。</p>
    <p>6.请及时保存或备份您的文字、图片等其他信息。您需理解并接受，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
    <p>7.尽管有前述的安全措施，但同时也请您理解在网络上不存在“百分百的安全”。在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</p>
    <h3 style="font-size: 0.16rem;">五、您如何管理您的个人信息</h3>
    <p>1.您可以随时登录联考之家个人中心等栏目，查询、完善自己的账户信息，更改安全设置，修改密码、邮箱、手机号等个人信息。</p>
    <p>2、您可通过在设备系统中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。</p>
    <p>3.您可通过“联考之家App-我的-注销账号”路径注销您的联考之家账号，注销成功后，我们将删除您的账号相关信息，或对其进行匿名化处理，您将无法使用联考之家的服务，您与联考之家之间的权利义务全部终止。</p>
    <p>4.您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您随时联系我们。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。</p>
    <h3 style="font-size: 0.16rem;">六、本隐私政策的变更</h3>
    <p>本隐私政策的内容可能会不时更新，以适应法律、技术或业务的发展。更新后的隐私政策将在联考之家网站上公布，重大变更将以网站公告、用户通知等合适的形式告知用户。当您使用我们的网站时，您可以随时审阅我们的隐私政策，以便您了解其修改。您可以在本文顶部的“生效日期”处查看本政策的最近更新日期。</p>
    <p>若您在本隐私政策修订后继续使用联考之家提供的产品和服务，即表示您已充分阅读、理解并接受修订后的本政策并同意我们按照修订后的政策收集、使用、保存、共享、转让或披露您的相关信息。</p>
    <h3 style="font-size: 0.16rem;">七、法律适用与管辖</h3>
    <p>本隐私政策的成立、生效、履行、解释及纠纷解决均受到中华人民共和国大陆地区法律（不包含冲突法）的法律管辖。如其中任何条款与中华人民共和国法律相抵触，则这些条款将完全按法律规定重新解释，而其他条款依旧具有法律效力。您与联考之家就本隐私政策或其他有关事项发生的争议，应首先友好协商解决，协商不成时，应将纠纷或争议提请联考之家备案归属地有管辖权的法院管辖。</p>
    <h3 style="font-size: 0.16rem;">八、联系我们</h3>
    <p>如果您对本政策内容有任何疑问、意见或建议，或者您发现个人信息可能被泄露，您可以通过以下方式与我们联系，我们将在15天内回复。</p>
    <p>个人信息保护专用邮箱：shang@tian.com.cn</p>
  </div>
</template>

<script>

export default {
  name: 'Policy',
  data() {
    return {}
  },
  created() {},
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.content {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}
.content-data {
  display: inline-block;
  text-align: center;
  width: 10rem;
  padding-bottom: 0.03rem;
  font-size: 0.12rem;
}
p {
  font-size: 0.13rem;
  font-family: tahoma, arial, 'Microsoft YaHei', "Hiragino Sans GB", SimSun, sans-serif;
  text-indent: 0.26rem;
  margin-bottom: 0.08rem;
  margin-top: 0.08rem;
  line-height: 0.22rem;
  text-align:justify;
}
</style>
